import { render, staticRenderFns } from "./huapuWater.vue?vue&type=template&id=68226155&scoped=true&"
import script from "./huapuWater.vue?vue&type=script&lang=js&"
export * from "./huapuWater.vue?vue&type=script&lang=js&"
import style0 from "./huapuWater.vue?vue&type=style&index=0&id=68226155&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68226155",
  null
  
)

export default component.exports